import BackgroundImage from "../../../components/ui/BackgroundImage";
import bgImage from "../assets/images/memory-bg.webp";
import GameBoard from "./GameBoard";
import GameProgress from "./GameProgress";
import Header from "./Header";
import { useMemoryGame } from "../hooks/use-memory-game";
import { motion, AnimatePresence } from "framer-motion";
import Scenarios from "./Scenarios";
import AttemptsPopup from "./AttemptsPopup";

const MemoryMinigame = ({ className = "" }: { className?: string }) => {
  const {
    tiles,
    gridSize,
    stats,
    isPreviewing,
    isRunning,
    isGameOver,
    isLevelComplete,
    areAllLevelsCompleted,
    setCurrentLevel,
    clickTile,
    startGame,
    resetGame,
    nextLevel,
  } =
    useMemoryGame(/*{
    onWin: ({ stats, level, gridSize, path, tiles, areAllLevelsCompleted }) => {
      if (areAllLevelsCompleted) {
        alert("You finished all levels! final stats: " + JSON.stringify(stats));
      } else {
        alert("Level " + level + " complete — call nextLevel() to continue.");
      }
    },
    onLose: ({ stats }) => {
      alert("You lost. stats:" + JSON.stringify(stats));
    },
  } */);

  return (
    <BackgroundImage
      imageSrc={bgImage}
      className={`w-full h-screen flex items-center justify-center overflow-hidden  ${className}`}
    >
      <AnimatePresence>
        <motion.div
          key="animated-box"
          initial={{ opacity: 0, y: 50 }} // start position (below)
          animate={{ opacity: 1, y: 0 }} // visible
          exit={{ opacity: 0, y: 50 }} // leave down
          transition={{ duration: 0.4, ease: "easeOut" }}
          className=""
        >
          <main className="bg-gradient-to-r from-[#161b26]/95 via-[#2c364a]/90 to-[#161b26]/95 rounded-[56px] p-6 relative">
            <div className="border-[1px] border-white/15 rounded-[46px] p-8">
              <Header
                titleWords={[
                  { word: "MEMORY" },
                  { word: "MINIGAME", isHighlighted: true },
                ]}
                onClose={() => {}}
              />
              <GameProgress
                attempts={stats.attemptsLeft}
                points={stats.points}
                levelStage={stats.level}
                className="my-4"
              />
              <div>
                <GameBoard
                  tiles={tiles}
                  gridSize={gridSize}
                  clickTile={clickTile}
                  isGameOver={isGameOver}
                />
                {isRunning && (
                  <AttemptsPopup attemptsLeft={stats.attemptsLeft} />
                )}
              </div>
              {isPreviewing
                ? null
                : (isGameOver || isLevelComplete || !isRunning) && (
                    <Scenarios
                      areAllLevelsFinished={areAllLevelsCompleted}
                      isLevelComplete={isLevelComplete}
                      stats={stats}
                      isGameOver={isGameOver}
                      isRunning={isRunning}
                      gridSize={gridSize}
                      setCurrentLevel={setCurrentLevel}
                      resetGame={resetGame}
                      nextLevel={nextLevel}
                      startGame={startGame}
                    />
                  )}
            </div>
          </main>
        </motion.div>
      </AnimatePresence>
    </BackgroundImage>
  );
};

export default MemoryMinigame;
